document.addEventListener('click', function (event) {
  var pill = event.target.closest('[data-xtm-search-suggestion]');
  if (!pill) return;

  var panel = pill.closest('.xtm-search-panel');
  var input = panel && panel.querySelector('input[type="search"]');
  if (!input) return;

  input.value = pill.getAttribute('data-xtm-search-suggestion') || '';
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.focus();
});
